import moment from 'moment';
import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  rebateSystemSerchResult: [],
  procedureTypeDropDown: [],
  procedureDetials: [],
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_PROCESS_DETAILS:
      return { ...state, procedureDetials: action.procedureDetials };

    case actionTypes.GET_PROCEDURE_RESULT_DETAILS:
      const no_record = 'No Record';
      const record_exist = 'record_exist';
      const msg =
        action.rebateSystemSerchResult &&
        action.rebateSystemSerchResult.length === 0
          ? no_record
          : record_exist;
      return {
        ...state,
        rebateSystemSerchResult: action.rebateSystemSerchResult,
        msg: msg,
      };
    case actionTypes.GET_PROCEDURE_TYPE:
      return { ...state, procedureTypeDropDown: action.procedureTypeDropDown };

    default:
      return state;
  }
};

export default reducer;
